import React from 'react';
import classNames from 'classnames';
import copyProps from '../utils/copy-props';
import addClassName from '../utils/add-class-name';
import VstButton from './VstButton';
import VstComponent from './VstComponent';

class VstProgressButton extends VstComponent {
  constructor() {
    super();
    this._incrementProgress = this._incrementProgress.bind(this);
    this._clearTimeouts = this._clearTimeouts.bind(this);
    this._reset = this._reset.bind(this);
    this._onClick = this._onClick.bind(this);
    this.state = { progress: 0 };
  }

  componentWillUnmount() {
    this._clearTimeouts();
  }

  componentWillReceiveProps(nextProps) {
    const f = (p) => {
      this._clearTimeouts();
      this.setState({ progress: p });
      setTimeout(this._reset, 1300);
    };

    if (nextProps.success) {
      f(100);
    } else if (nextProps.success === false) {
      f(100);
    }
  }

  _clearTimeouts() {
    clearTimeout(this._incrementTimeout);
  }

  _incrementProgress(el) {
    this._incrementTimeout = setTimeout(() => {
      let newProgress = this.state.progress + Math.floor(Math.random() * 10);
      newProgress = Math.min(newProgress, 99);
      this.setState({ progress: newProgress });
      this._incrementProgress(el);
    }, 100);
  }

  _reset() {
    this.setState({ progress: 0 });
    if (this.props.onReset) { this.props.onReset(); }
  }

  _onClick(e) {
    if (this.state.progress === 0) {
      this._incrementProgress(this.refs.progress);
    }
    if (this.props.onClick) { this.props.onClick(e); }
  }

  render() {
    const props = addClassName(this.props, 'vst-progress-button');

    let buttonText;
    if (this.props.success) {
      buttonText = this.props.successText || 'Done';
    } else if (this.props.success === false) {
      buttonText = this.props.failureText || 'Failed';
    } else if (this.state.progress > 0) {
      buttonText = this.props.progressText || 'Saving...';
    } else {
      buttonText = this.props.children;
    }

    const isSuccess = this.props.success && this.state.progress >= 100;
    const isFailure = this.props.success === false;

    return (
      <VstButton {...copyProps(props, ['success', 'progressText', 'failureText', 'successText'])} onClick={this._onClick}>
        <span className={classNames('wrapper', { success: isSuccess, failure: isFailure })}>
          <span className="content" ref="text">{buttonText}</span>
          <span className={classNames('progress', { 'no-transition': this.state.progress === 0 || this.state.progress === 100 })}
            style={{ width: `${this.state.progress}%`, backgroundColor: this._theme(9) }}
            ref="progress"
          />
        </span>
      </VstButton>
    );
  }
}

export default VstProgressButton;
